"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fachgruppeInputSchema = exports.fachgruppeSchema = exports.companyInputSchema = exports.companySchema = exports.tenantInputSchema = exports.tenantSchema = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
/** Transport-safe representation of the existing Prisma Tenant row. */
exports.tenantSchema = zod_1.z.strictObject({
    id: common_js_1.uuidSchema,
    slug: common_js_1.textSchema,
    name: common_js_1.textSchema,
    isActive: zod_1.z.boolean(),
    createdAt: common_js_1.timestampSchema,
    updatedAt: common_js_1.timestampSchema,
});
exports.tenantInputSchema = exports.tenantSchema.pick({ slug: true, name: true });
/** Company and discipline are tenant data, not the mockup's SBI/WBI or six-value lists. */
exports.companySchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: exports.tenantSchema.shape.id,
    name: common_js_1.textSchema,
});
exports.companyInputSchema = exports.companySchema.pick({ name: true });
exports.fachgruppeSchema = zod_1.z.strictObject({
    id: common_js_1.idSchema,
    tenantId: exports.tenantSchema.shape.id,
    name: common_js_1.textSchema,
});
exports.fachgruppeInputSchema = exports.fachgruppeSchema.pick({ name: true });
//# sourceMappingURL=organisation.js.map